import { create } from "zustand";
import { sessionStore, type Session } from "./api/client";
import { log } from "./logger";

interface SessionState {
  session: Session | null;
  setSession: (s: Session | null) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  session: sessionStore.load(),
  setSession: (s) => {
    if (s) {
      sessionStore.save(s);
      log.auth("session set", {
        userId: s.userId.slice(0, 8) + "…",
        workspaceId: s.workspaceId.slice(0, 8) + "…",
      });
    } else {
      sessionStore.clear();
      log.auth("session cleared");
    }
    set({ session: s });
  },
}));

// Sync Zustand state when the API client clears localStorage on a failed
// refresh (e.g. server rejected a stale DEV_MOCK token). Without this hook
// the React tree keeps the in-memory session and the user sees endless 401s
// instead of being redirected to /sign-in.
if (typeof window !== "undefined") {
  window.addEventListener("isale:session-cleared", () => {
    log.auth("session cleared via window event (stale token purge)");
    useSessionStore.getState().setSession(null);
  });
}
